import { TrailerImageModel } from './trailerImageModel';
import { OrderModel } from '@core/api';
import { GasNetworkModel, GasStationModel } from '@core/api';

export interface TrailerModel {
  id?: number;
  registration_network: string;
  registration_number: string;
  type: TrailerModel.TypeEnum;
  status: TrailerModel.StatusEnum;
  brand?: string;
  model?: string;
  load_capacity?: number;
  gas_station_id: number;
  origin_gas_station_id?: number;
  /** When true, intercity return is forbidden even if a station has free transit spaces. */
  non_transit?: boolean;
  updated_at?: Date;
  created_at?: Date;
  damage?: boolean;
  plug_adapter_seven_to_thirteen?: boolean;
  spare_wheel?: boolean;
  images?: TrailerImageModel[],
  order?: OrderModel
  gasNetwork?: GasNetworkModel,
  gasStation?: GasStationModel,
  originGasStation?: GasStationModel,
}

export namespace TrailerModel {
  export type TypeEnum = 'with_tent' | 'without_tent';
  export const TypeEnum = {
    WithTent: 'with_tent' as TypeEnum,
    WithoutTent: 'without_tent' as TypeEnum
  };
  export type StatusEnum = 'available' | 'service' | 'in_rent' | 'registration' | 'acceptance';
  export const StatusEnum = {
    Available: 'available' as StatusEnum,
    Service: 'service' as StatusEnum,
    InRent: 'in_rent' as StatusEnum,
    Registration: 'registration' as StatusEnum,
    Acceptance: 'acceptance' as StatusEnum
  };
}
